import { observable } from 'mobx';

export default class Practioner {
    @observable practFirst;
    @observable practLast;
    @observable pracNPI;
  
    constructor({practFirst = '', practLast = '', pracNPI = ''} = {}) {
      this.practFirst = practFirst;
      this.practLast = practLast;
      this.pracNPI = pracNPI;
    }
  }